export default __webpack_public_path__ + "static/media/fpb60200.dda10541.png";